export function whenMapCapabilitiesToPropsIsFunction(mapCapabilitiesToProps) {
    return (typeof mapCapabilitiesToProps === 'function')
        ? () => (props) => mapCapabilitiesToProps(props)
        : undefined;
}
export function whenMapCapabilitiesToPropsIsObject(mapCapabilitiesToProps) {
    return (mapCapabilitiesToProps && typeof mapCapabilitiesToProps === 'object')
        ? () => () => mapCapabilitiesToProps
        : undefined;
}
const factories = [
    whenMapCapabilitiesToPropsIsFunction,
    whenMapCapabilitiesToPropsIsObject
];
export default function matchCapabilitiesToProps(arg) {
    for (let i = factories.length - 1; i >= 0; i--) {
        const result = factories[i](arg);
        if (result)
            return result;
    }
    return (options) => {
        throw new Error(`Invalid value of type ${typeof arg} for mapCapabilitiesToProps argument when connecting component ${options.wrappedComponentName}.`);
    };
}
